import apiClient from '@/services/axios'

export async function post(venueMail, messageId, fileName) {

    var response = await apiClient({
        method: 'post',
        url: process.env.VUE_APP_CRM_API_BASE_URL + `/EngageEmail/attachment/download?venueMail=${venueMail}&messageId=${messageId}&fileName=${fileName}`,
        responseType: 'blob'
    })
    if (response) {
        console.log(response.data);
        return response.data
    }

    throw new Error('Unable to download attachment')
}
